/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared quickview snippet. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* capkov-rd: "Get design advice" popup. Sends JSON to Gatherino (form capkov-poradit-s-navrhem, market=eu, language=en; no page leave, no captcha; honeypot + time trap + limits handled by Gatherino). On network/server failure it is sent via Shopify /contact in a new tab. */
(function () {
  'use strict';
  /* GATHERINO: when going live change ONLY the host (gatherino.com -> gatherino.com); the only place in this file. */
  var ENDPOINT = 'https://gatherino.com/api/embed/forms/capkov-poradit-s-navrhem/submit';
  var root = document.querySelector('[data-rdc]'); if (!root) return;
  var box = root.querySelector('.rdc__box'), form = root.querySelector('[data-rdc-form]');
  var err = root.querySelector('[data-rdc-err]'), go = root.querySelector('[data-rdc-go]');
  var wrap = root.querySelector('[data-rdc-formwrap]'), ok = root.querySelector('[data-rdc-ok]');
  var opener = null, timer = 0, openedAt = 0;
  function q(s) { return document.querySelector(s); }
  function context() {
    var L = [], loc = location.href.replace(/[?&](rd_text|rd_thread|rd_open)=[^&]*/g, '');
    var h1 = q('h1'); var title = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants[0] && ShopifyAnalytics.meta.product.variants[0].name) || (h1 && h1.textContent.trim()) || document.title;
    L.push('Page: ' + title); L.push('URL: ' + loc);
    var v = new URLSearchParams(location.search).get('variant'); if (v) L.push('Variant: ' + v);
    var t = q('[data-capkov-text]'); if (t && t.value) L.push('Text in the designer: ' + t.value);
    try { var st = JSON.parse(sessionStorage.getItem('rd_ub_state_v1') || 'null'); if (st && st.base) L.push('Guide: ' + [st.base, st.color, st.size, st.tech, st.text].filter(Boolean).join(' / ')); } catch (e) { }
    return L.join('\n');
  }
  function ctxObj() {
    var h1 = q('h1'), M = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var prod = (M && M.variants && M.variants[0] && M.variants[0].name) || (h1 && h1.textContent.trim()) || document.title;
    var t = q('[data-capkov-text]'), st = null;
    try { st = JSON.parse(sessionStorage.getItem('rd_ub_state_v1') || 'null'); } catch (e) { }
    var guide = st && st.base ? [st.base, st.color, st.size, st.tech, st.text].filter(Boolean).join(' / ') : '';
    var v = new URLSearchParams(location.search).get('variant') || '';
    return { produkt: String(prod || '').slice(0, 120), url: location.href.replace(/[?&](rd_text|rd_thread|rd_open)=[^&]*/g, '').slice(0, 500), varianta: v, text: (t && t.value) || guide || '', shop: (window.Shopify && Shopify.shop) || location.hostname };
  }
  function focusables() { return [].slice.call(box.querySelectorAll('button,input,textarea,a[href]')).filter(function (e) { return !e.disabled && e.offsetParent !== null; }); }
  function open(from) {
    opener = from || document.activeElement; clearTimeout(timer);
    openedAt = Date.now(); wrap.hidden = false; ok.hidden = true; err.hidden = true; go.disabled = false;
    document.body.appendChild(root); /* nad modalem builderu (same z-index, the later element wins) */
    root.hidden = false; document.body.classList.add('rdc-lock');
    var m = form.querySelector('[name="contact[email]"]'); setTimeout(function () { m.focus(); }, 50);
  }
  function close() {
    clearTimeout(timer); root.hidden = true; document.body.classList.remove('rdc-lock');
    if (opener && opener.focus) try { opener.focus({ preventScroll: true }); } catch (e) { }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rd-consult]');
    if (a) { e.preventDefault(); open(a); return; }
    if (e.target.closest && e.target.closest('[data-rdc-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  function fallback(body, email) {
    var f = document.createElement('form'); f.method = 'post'; f.action = form.action; f.target = '_blank'; f.acceptCharset = 'UTF-8'; f.style.display = 'none';
    [['form_type', 'contact'], ['utf8', '✓'], ['contact[email]', email], ['contact[body]', body]].forEach(function (p) { var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; f.appendChild(i); });
    document.body.appendChild(f); f.submit(); setTimeout(function () { f.remove(); }, 1000);
  }
  function success() {
    wrap.hidden = true; ok.hidden = false; form.reset();
    timer = setTimeout(close, 2500);
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault(); err.hidden = true;
    var email = form.elements['contact[email]'].value.trim(), msg = form.elements['contact[body]'].value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = rdOT("please_enter_a_valid_email_address_d2306dd", "Please enter a valid email address."); err.hidden = false; form.elements['contact[email]'].focus(); return; }
    if (!msg) { err.textContent = rdOT("please_write_us_a_message_5efa917", "Please write us a message."); err.hidden = false; form.elements['contact[body]'].focus(); return; }
    var ins = form.elements['rdc_inspiration'].value.trim();
    var body = msg + (ins ? '\n\nInspiration: ' + ins : '') + '\n\n---\n' + context();
    go.disabled = true;
    function fail(msg, fb) { if (fb) fallback(body, email); err.textContent = msg; err.hidden = false; go.disabled = false; }
    var c = ctxObj();
    var payload = { email: email, zprava: msg, inspirace: ins, kontext_produkt: c.produkt, kontext_url: c.url, kontext_varianta: c.varianta, kontext_text: c.text, kontext_shop: c.shop, locale: ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 5), market: 'eu', language: 'en', hp: form.elements['rdc_hp'].value, t: String(Date.now() - openedAt) };
    var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'omit', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      clearTimeout(to);
      if (r.status === 200) { success(); return; }
      if (r.status === 400 || r.status === 429) { return r.json().catch(function () { return {}; }).then(function (j) { fail(j.error || (r.status === 429 ? rdOT("too_many_messages_please_try_again_later_6a72cf4", "Too many messages, please try again later.") : rdOT("the_message_could_not_be_sent_please_check_your__20bc9c3", "The message could not be sent, please check your details.")), false); }); }
      fail(rdOT("sending_failed_please_email_us_at_support_capkov_4fd4f12", "Sending failed. Please email us at support@capkov.com and we will reply right away."));
    }).catch(function () { clearTimeout(to); fail(rdOT("the_connection_failed_please_email_us_at_support_3ed2229", "The connection failed. Please email us at support@capkov.com and we will reply right away.")); });
  });
})();

})();
